import { ErrorToast, Icon, PlusIcon, TrashIconRed } from '@vgrubs/components';
import Compressor from 'compressorjs';
import { useRef } from 'react';
import styled from 'styled-components';

const ImageInputStyled = styled.div`
  width: 130px;
  height: 130px;
  cursor: pointer;
  position: relative;
  background: ${({ theme }) => theme.white};
  border-radius: 50%;

  > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 130px;
    height: 130px;
    border-radius: 50%;
    overflow: hidden;

    > img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }

    > div {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  input {
    visibility: hidden;
    height: 0;
    width: 0;
  }
`;

const BorderStyled = styled.div`
  border: 1px solid ${({ theme }) => theme.primary};
  padding: 8px;
  border-radius: 50%;
`;

const DeleteIconStyled = styled.span`
  position: absolute;
  right: 0px;
  top: 0px;
  cursor: pointer;
`;

export const ImageInput = ({
  image,
  onChange,
  onDelete,
}: {
  image: string | Blob | File | null;
  onChange: (image: string | Blob | File) => void;
  onDelete?: () => void;
}) => {
  const imageUrl =
    typeof image === 'string' ? image : image && URL.createObjectURL(image);

  const inputFileRef = useRef<HTMLInputElement>(null);

  const onBtnClick = () => {
    inputFileRef.current?.click();
  };

  const handleChange = (e) => {
    const files = e.target.files;
    const file = files[0];
    const maxSize = 2097152;


    if (files.length) {
      new Compressor(file, {
        quality: 0.8,
        maxWidth: 2500,
        maxHeight: 1500,
        convertSize: 2097152,
        success: (compressedResult) => {
          if (compressedResult.size > maxSize) {
            return ErrorToast('Image file too big');
          } else {
            onChange(compressedResult);
          }
        },
      });
    }
  };

  const onDeleteClick = (e) => {
    e.stopPropagation();
    onDelete?.();
  };

  return (
    <BorderStyled>
      <ImageInputStyled onClick={onBtnClick}>
        <input ref={inputFileRef} type="file" onChange={handleChange} />

        <div>
          {image ? (
            <img src={imageUrl || undefined} alt="add brand" />
          ) : (
            <div>
              <PlusIcon />
            </div>
          )}
        </div>

        {onDelete && image && (
          <DeleteIconStyled onClick={onDeleteClick}>
            <Icon>
              <TrashIconRed />
            </Icon>
          </DeleteIconStyled>
        )}

        {/* <Img src={plate} $width="130px" alt="add brand" /> */}
      </ImageInputStyled>
    </BorderStyled>
  );
};
